import { DriveProvider } from '@risk-and-safety/drive-client';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { useProfile } from '../hooks';
import { getImpersonateId } from '../shared/helper';

export default function Session({ children }) {
  const { profile } = useProfile();
  const [impersonateId, setImpersonateId] = useState('');

  useEffect(() => {
    async function load() {
      setImpersonateId(getImpersonateId());
    }

    load();
  }, []);

  return (
    <DriveProvider userId={profile?.userId || ''} impersonateId={impersonateId}>
      {children}
    </DriveProvider>
  );
}

Session.propTypes = {
  children: PropTypes.node.isRequired,
};
